<template>
	<div id="auth"></div>
</template>

<script>
export default {
	name: "getAuth",
	props: {},
	data() {
		return {
			toastInst: null
		};
	},
	computed: {},
	watch: {},
	beforeCreate() {
        let fromHome = sessionStorage.getItem("fromHome");
        if (ua === "wx") {
			if (fromHome&&!sessionStorage.isShareTo) {
				//关闭安卓系统的手机
				document.addEventListener(
					"WeixinJSBridgeReady",
					function() {
						WeixinJSBridge.call("closeWindow");
					},
					false
				);
				//关闭ios系统的手机
				WeixinJSBridge.call("closeWindow");
            }
        }
        //点击图片链接进入，不授权
        if(sessionStorage.token){
            const shareto = UTILS.getQueryString("shareto");
            const shareId = UTILS.getQueryString("shareid");
            if (shareto) {
                if (shareId) {
                    this.$router.replace(
                        `/scene?shareto=${shareto}&shareid=${shareId}`
                    );
                } else {
                    this.$router.replace(`/scene?shareto=${shareto}`);
                }
            } 
            return false;
        }	
		if (ua === "wx" && !UTILS.getQueryString("openid")) {
			let link = `${window.location}`;
			const shareto = UTILS.getQueryString("shareto");
			// if (shareto) {
			// 	link = link.split("#")[0];
			// }
			link = link.split("#")[0];
			//拼接获取openid后后台返回的链接地址
			location.replace(
				`${API.baseUrl}/wxuser?url=${encodeURIComponent(link)}`
			);
		}
	},
	created() {
		const code = UTILS.getAuthCodeFromHref();
		if (UTILS.getQueryString("promoteStr")) {
			localStorage.promoteStr = UTILS.getQueryString("promoteStr");
		}
		if (UTILS.getQueryString("fromChannel")) {
			sessionStorage.fromChannel = UTILS.getQueryString("fromChannel");
		}
		if (UTILS.getQueryString("fromPoint")) {
			sessionStorage.fromPoint = UTILS.getQueryString("fromPoint");
		}
		if (UTILS.getQueryString("ticketId")) {
			sessionStorage.firstTicketId = UTILS.getQueryString("ticketId");
		}
		if (UTILS.getQueryString("type")) {
			sessionStorage.firstTypeId = UTILS.getQueryString("type");
		}
		if (ua === "alipay" && !UTILS.getQueryString("promoteStr")) {
			if (sessionStorage.getItem("alipayAuthCode") != "first") {
				sessionStorage.alipayAuthCode = "first";
				UTILS.redirectToGetAuthCode();
			}
		}
		if (!code) {
			//游客不能使用支付宝扫描推广员推广码进行下单
			if (ua === "alipay" && UTILS.getQueryString("promoteStr")) {
				// this.$toast("请使用微信扫码下单！");
				this.$router.replace("/notAllowUseAli");
				// setTimeout(()=>{
				//     AlipayJSBridge.call("closeWebview");
				// },3000);
			} else {
				UTILS.redirectToGetAuthCode();
			}
		} else {
			this.toastInst = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true, // 禁用背景点击
				loadingType: "spinner",
				message: "登录中..."
			});
			UTILS.getUserInfo(
				code,
				() => {
					const shareto = UTILS.getQueryString("shareto");
					const shareId = UTILS.getQueryString("shareid");
					const fromChannelStr = UTILS.getQueryString("fromChannel");
                    this.toastInst.clear();
					if (shareto) {
						if (shareId) {
							this.$router.replace(
								`/scene?shareto=${shareto}&shareid=${shareId}`
							);
						} else {
							this.$router.replace(`/scene?shareto=${shareto}`);
						}
					} else {
						if (sessionStorage.link) {
                            location.replace(sessionStorage.link);
                            sessionStorage.removeItem("link");
							return false;
						}
						this.$router.replace({ name: "scene" });
					}
				},
				() => {
					this.$toast("获取不到用户信息，请刷新后重试！");
					setTimeout(() => this.toastInst.clear(), 3000);
				}
			);
		}
	},
	mounted() {},
	destroyed() {},
	methods: {}
};
</script>

<style scoped lang="scss">
#auth {
	width: 100%;
	min-height: 100%;
	background: #fff;
}
</style>

